import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table } from 'antd';
import {
  queryDeleteFunction,
  queryFunctionInfo,
  queryFunctionListTree,
  querySaveFunction,
} from '@api/core/function';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import ModalFunctionAdd from './ModalFunctionAdd';

const FormItem = Form.Item;

const typeNames = {
  A: '系统分类',
  C: '导航分类',
  N: '功能导航',
  B: '功能按钮',
};

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      parentLevelCode: '',
      isPermission: false,
      visible: false,
      dataInfo: null,
    };
  }

  componentDidMount() {
    this.loadData(null, 1);
    this.judge(this.props.account_info);
  }

  componentWillUnmount() {
    this.props.dispatch(setBackInfo({}));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  // 加载需公司账户信息数据
  loadData = () => {
    const params = {};
    this.setState({
      isLoading: true,
    });
    queryFunctionListTree(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          isLoading: false,
        });
      }
    });
  };

  // 菜单栏详情
  getFunctionInfo = uuid => {
    queryFunctionInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        const { levelCode } = res.data;
        let parentLevelCode;
        if (levelCode && levelCode.length > 2) {
          parentLevelCode = levelCode.slice(0, levelCode.length - 2);
        }
        this.setState({
          dataInfo: res.data || [],
          parentLevelCode: parentLevelCode || '',
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  saveFunction = params => {
    querySaveFunction(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerVisible(false);
        this.setState({ dataInfo: null });
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  deleteFunction = uuid => {
    queryDeleteFunction({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData();
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = accountInfo => {
    let isPermission = false;
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState({
      isPermission,
    });
  };

  handlerVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '名称',
        dataIndex: 'funName',
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: text => {
          return <span>{text === 1 ? '启用' : '禁用'}</span>;
        },
      },
      {
        title: '服务名称',
        dataIndex: 'resource',
      },
      {
        title: '加载目标',
        dataIndex: 'target',
      },
      {
        title: '功能项类型',
        dataIndex: 'type',
        render: text => {
          return <span>{typeNames[text]}</span>;
        },
      },
      {
        title: '图标资源',
        dataIndex: 'pic',
      },
      {
        title: '备注',
        dataIndex: 'remark',
      },
      {
        title: '操作',
        render: (text, record) => {
          const { isPermission } = this.state;
          return (
            <span>
              {isPermission ? (
                <span>
                  <a onClick={() => this.addFunction(record.levelCode)}>新增</a>
                  <span className="ant-divider" />
                  <a onClick={() => this.editFunction(record.uuid)}>编辑</a>
                  <span className="ant-divider" />
                  <Popconfirm
                    onConfirm={() => this.deleteFunction(record.uuid)}
                    title="确定删除当前菜单栏吗？"
                    placement="topRight"
                    overlayStyle={{ width: 200 }}
                  >
                    <a className="ant-dropdown-link">删除</a>
                  </Popconfirm>
                </span>
              ) : null}{' '}
            </span>
          );
        },
      },
    ];
  };

  addFunction = levelCode => {
    levelCode && this.setState({ parentLevelCode: levelCode });
    this.setState({ dataInfo: null });
    this.handlerVisible(true);
  };

  editFunction = uuid => {
    this.getFunctionInfo(uuid);
    this.handlerVisible(true);
  };

  render() {
    const { data, isLoading, parentLevelCode, isPermission, visible, dataInfo } = this.state;
    return (
      <div>
        <Card>
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13}>
              {isPermission ? (
                <Button type="primary" onClick={() => this.addFunction('')}>
                  添加
                </Button>
              ) : null}
            </Col>

            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
          <Table
            rowKey="uuid"
            loading={isLoading}
            columns={this.columns()}
            dataSource={data}
            pagination={false}
          />
          <ModalFunctionAdd
            parentLevelCode={parentLevelCode}
            visible={visible}
            data={dataInfo}
            onOk={params => this.saveFunction(params)}
            onCancel={() => this.handlerVisible(false)}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/boss/function/Index.js